import { useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { TableBody } from "../TablesBasePage/TableBody";
import { TableHeader } from "../TablesBasePage/TableHeader";

const charakteristischeEinwirkungenHeaderDefinitions = {
  header: [
    {
      columns: [
        {
          title: "typ",
          path: "typ",
          disabled: true,
          filtered: false,
          type: "string",
          translationKey: "tables.charakteristischeneinwirkungen.typ",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_G",
          path: "GAMMA_G",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_G",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_Q",
          path: "GAMMA_Q",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_Q",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_G_E0",
          path: "GAMMA_G_E0",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_G_E0",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_G_INF",
          path: "GAMMA_G_INF",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_G_INF",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_M",
          path: "GAMMA_M",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_M",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_c",
          path: "GAMMA_c",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_c",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_cu",
          path: "GAMMA_cu",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_cu",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_s",
          path: "GAMMA_s",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_s",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_st",
          path: "GAMMA_st",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_st",
          translationNamespace: "tables",
        },
        {
          title: "Eta_M",
          path: "Eta_M",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.Eta_M",
          translationNamespace: "tables",
        },
        {
          title: "GAMMA_ff",
          path: "GAMMA_ff",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.charakteristischeneinwirkungen.GAMMA_ff",
          translationNamespace: "tables",
        },
      ],
    },
  ],
};

export default function CharakteristischenEinwirkungen({
  functions: charakteristischeEinwirkungenFunctions,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 20;

  const { isLoading, data: elements } = charakteristischeEinwirkungenFunctions.GetAll();

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    let res = elements?.slice(firstPageIndex, lastPageIndex);
    if (res?.length === 0 && currentPage !== 1) setCurrentPage(currentPage - 1);
    return res;
  }, [pageSize, currentPage, elements]);

  if (isLoading) return <p>loading...</p>;
  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          {!isLoading && (
            <>
              <TableHeader
                headerDefs={charakteristischeEinwirkungenHeaderDefinitions}
                translationPrefix={"tables.charakteristischeneinwirkungen"}
              />
              <TableBody
                columns={charakteristischeEinwirkungenHeaderDefinitions.header[0].columns}
                currentTableData={currentTableData}
                functions={charakteristischeEinwirkungenFunctions}
              />
            </>
          )}
        </table>
      </div>

      {elements && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={elements?.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
}
